export const BASE_URL = "https://www.fasttrade.com.sa/testauction";